import React, { Fragment, useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import * as apiUrl from "../../apiUrl";

function MilestoneBanner() {
  const [MilestoneBanner, setMilestoneBanner] = useState({});

  useEffect(() => {
    const fetchMilestoneBanner = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/milestones/banner-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setMilestoneBanner(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchMilestoneBanner();
  }, []);

  return (
    <Fragment>
      <div
        className="common-banner-sec common-flex-center milestone-banner"
        style={{
          backgroundImage: `url(${
            apiUrl.apiUrl + `/` + MilestoneBanner.banner_image
          })`,
        }}
      >
        <div className="overlay"></div>
        <Container fluid>
          <Row className="common-flex-center">
            <Col md={8}>
              <div className=" ">
                <h1 className="common-head whiteColor">{MilestoneBanner.banner_title}</h1>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Fragment>
  );
}

export default MilestoneBanner;
